module.exports = __webpack_public_path__ + "static/media/midrive.40870a0e.png";